import { render } from "./MonitoraggioPuntualeForm.vue?vue&type=template&id=b8ef2f7e"
import script from "./MonitoraggioPuntualeForm.vue?vue&type=script&lang=js"
export * from "./MonitoraggioPuntualeForm.vue?vue&type=script&lang=js"

import "./MonitoraggioPuntualeForm.vue?vue&type=style&index=0&id=b8ef2f7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__